import React, { useState, useRef, useCallback ,useEffect} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FadeLoader, PulseLoader } from "react-spinners";
import HTMLModal from "react-modal";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import Button from "react-bootstrap/Button";
import ResModal from "react-bootstrap/Modal";
import { apiPost, apiPostFormData, apiPut } from "./utils/apiAuth";
import config from "./config";

// Components
import Modal from "./Component/Modals/Modal";
import Header from "./components/ContentCreation/Header";
import FormSection from "./components/ContentCreation/FormSection";
import TopicSelector from "./components/ContentCreation/TopicSelector";
import QuestionSelector from "./components/ContentCreation/QuestionSelector";
import MCQForm from "./components/ContentCreation/MCQForm";
import {
  buildQuizQuestionData,
  validateQuizForm,
} from "./utils/quizForm";
import VideoForm from "./components/ContentCreation/VideoForm";
import NotesForm from "./components/ContentCreation/NotesForm";
import CodingForm from "./components/ContentCreation/CodingForm";
import SQLForm from "./components/ContentCreation/SQLForm";
import HTMLForm from "./components/ContentCreation/HTMLForm";
import ProjectComponent from "./components/ContentCreation/vscodeEditor/ProjectComponent";
import CustomModal from "./Component/Modals/CustomModal";
import { FaEye } from "react-icons/fa";

// Custom Hook
import { useContentCreation } from "./hooks/useContentCreation";

// Styles
// Constants
import CONSTANTS, { EditorConstants, ContentTypeConstants } from "./constants/contentCreationConstants";
import { hasMeaningfulContent } from "./utils/contentValidation";
import { useToast } from "./components/Toast";
import { Box, IconButton, Typography, Paper } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ContentCreationRefactored() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const showSaveSuccess = useCallback((isEdit = false) => {
    toast.success(isEdit ? 'Changes saved successfully' : 'Content saved successfully');
  }, [toast]);
  const data = location.state?.data;
  // Ref for ProjectComponent to call save function
  const projectComponentRef = useRef(null);
  // Check freezeFilters from location.state first, then fallback to sessionStorage
  const freezeFilters = data?.freezeFilters === true || sessionStorage.getItem('contentCreation_freezeFilters') === 'true';

  // Keep sidebar/back navigation source in sync with how this page was opened
  useEffect(() => {
    try {
      if (data?.freezeFilters === true || data?.project_id) {
        sessionStorage.setItem('contentCreation_navSource', 'project');
      } else if (data && data.freezeFilters === false) {
        sessionStorage.setItem('contentCreation_navSource', 'content-bank');
        sessionStorage.removeItem('contentCreation_projectId');
        sessionStorage.removeItem('contentCreation_projectName');
      }
    } catch {
      // ignore
    }
  }, [data]);

  // Container status for project coding (shared with Header for delete button)
  const [containerStatus, setContainerStatus] = useState(() => {
    try {
      const stored = sessionStorage.getItem("projectCoding_containerStatus");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  useEffect(() => {
    if (containerStatus) {
      try {
        sessionStorage.setItem("projectCoding_containerStatus", JSON.stringify(containerStatus));
      } catch {}
    } else {
      try {
        sessionStorage.removeItem("projectCoding_containerStatus");
      } catch {}
    }
  }, [containerStatus]);

  // Use custom hook for state management
  const {
    // State
    videos,
    setVideos,
    files,
    setFiles,
    count,
    setCount,
    explain,
    setExplain,
    showSucModal,
    setShowSucModal,
    showEditModal,
    setShowEditModal,
    selectedDifficulty,
    setSelectedDifficultyWithSession,
    currentFile,
    setCurrentFile,
    hints,
    setHints,
    refreshKey,
    setRefreshKey,
    isModalOpen,
    setIsModalOpen,
    testCases,
    setTestCases,
    keywords,
    setKeywords,
    tags,
    settags,
    mcqtags,
    setmcqtags,
    isLoading,
    setIsLoading,
    examples,
    setExamples,
    defaultTemplate,
    setdefaultTemplate,
    code1,
    setCode1,
    code2,
    setCode2,
    DisplayFiles,
    setDisplayFiles,
    selectedTopic,
    setSelectedTopicWithSession,
    topics,
    setTopics,
    subTopics,
    setSubTopics,
    contentType,
    setContentTypeWithSession,
    mcqQuestion,
    setMCQQuestion,
    options,
    setOptions,
    quizOptions,
    setQuizOptions,
    quizTemplate,
    setQuizTemplate,
    error,
    setError,
    mcqExplanation,
    setMCQExplanation,
    selectedSubTopic,
    setSelectedSubTopicWithSession,
    selectedSubTopicName,
    SQLTestCases,
    setSQLTestCases,
    isHtmlModalOpen,
    setIsHtmlModalOpen,
    htmlContent,
    setHtmlContent,
    selectedTemplate,
    setSelectedTemplate,
    sqldata,
    setsqlData,
    sqlerror,
    setsqlError,
    selectedTables,
    setSelectedTables,
    sqlexplain,
    setsqlExplain,
    sqltags,
    setsqlTags,
    sqlhints,
    setsqlHints,
    sqlquery,
    setsqlQuery,
    sqlqn,
    setsqlQn,
    sqltable,
    setTable,
    sqlExpectedOutput,
    setSqlExpectedOutput,
    isQueryrun,
    setIsQueryrun,
    loading,
    setLoading,
    modalMessage,
    setModalMessage,
    resShowModal,
    setResShowModal,
    isContentTypeDisabled,
    sub_name,
    notesTitle,
    setNotesTitle,
    notesContent,
    setNotesContent,
    notesTime,
    setNotesTime,
    notesStatus,
    setNotesStatus,
    notesSequence,
    setNotesSequence,
    notesLevel,
    setNotesLevel,

    // Video specific state
    filteredVideos,
    setFilteredVideos,
    allVideos,
    setAllVideos,
    videoTitle,
    setVideoTitle,
    videoStatus,
    setVideoStatus,
    videoSequence,
    setVideoSequence,
    videoDetails,
    setVideoDetails,
    selectedVideo,
    setSelectedVideoWithSession,
    selectedNote,
    setSelectedNoteWithSession,
    selectedQuestion,
    setSelectedQuestionWithSession,
    codingQuestionText,
    setCodingQuestionText,
    selectedEditor,
    setSelectedEditorWithSession,

    // Functions
    fetchCount,
    fetchTopics,
    fetchNameOfFile,
    handleQuestionChange,
    handleRadioChangeDiff,
    handleVideoLevelChange,
    handleVideoStatus,
    videoFile,
    setVideoFile,
    videoDescription,
    setVideoDescription,
    videoTime,
    setVideoTime,
    videoLevel,
    setVideoLevel,
    isMCQ,
    isQuiz,
    isCoding,
  } = useContentCreation(data);

  // Fix: Create alias for setSelectedQuestion since hook exports setSelectedQuestionWithSession
  const setSelectedQuestion = setSelectedQuestionWithSession;

  const [formData, setFormData] = useState({});
  const videoFormRef = useRef();
  const notesFormRef = useRef();

  // Approval status from project content bank page
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [batchAssigned, setBatchAssigned] = useState(false);
  const [isReviewReadOnly, setIsReviewReadOnly] = useState(false);

  // Notes specific state
  const [allNotes, setAllNotes] = useState({});
  const [filteredNotes, setFilteredNotes] = useState([]);

  // HTML specific state
  const [pageName, setPageName] = useState("");
  const [htmlFiles, setHtmlFiles] = useState([]);
  const [htmlTestCases, setHtmlTestCases] = useState({});
  const [htmlRequirements, setHtmlRequirements] = useState([]);
  const [defaultTemplateContent, setDefaultTemplateContent] = useState("");
  const [htmlTemplate, setHtmlTemplate] = useState("");
  const [fileModificationTracker, setFileModificationTracker] = useState({});
  const [imagePath, setImagePath] = useState("");
  const [videoPath, setVideoPath] = useState("");
  const [questionId, setQuestionId] = useState("");
  const [showRegenerateModal, setShowRegenerateModal] = useState(false);
  const [filesToRegenerate, setFilesToRegenerate] = useState([]);
  const [htmlSelectedTestCases, setHtmlSelectedTestCases] = useState({});
  const [isQuestionLoading, setIsQuestionLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [loadedImageUrls, setLoadedImageUrls] = useState([]);
  const [jsKeywords, setJsKeywords] = useState({});
  const [loadedKeywords, setLoadedKeywords] = useState({});
  const [validateImageUrls, setValidateImageUrls] = useState(null);
  
  // Project coding description modal state
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [projectCodingDescription, setProjectCodingDescription] = useState("");
  const [projectScopeCollapsed, setProjectScopeCollapsed] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [htmlSaveResetKey, setHtmlSaveResetKey] = useState(0);
  
  // JS specific state - use ref to persist data across re-mounts
  const jsDataRef = useRef({ elements: [], elementIdCounter: 1, testCaseCounter: 1, parameterCounter: 1 });
  const [jsData, setJsData] = useState({ elements: [], elementIdCounter: 1, testCaseCounter: 1, parameterCounter: 1 });
  
  // JS data change handler
  const handleJSDataChange = useCallback((data) => {
    // Store the data for persistence across re-mounts
    jsDataRef.current = data;
    setJsData(data);
  }, []);

  // Image URLs handlers
  const handleImageUrlsChange = useCallback((data) => {
    setImageUrls(data);
  }, []);

  // Keywords handlers
  const handleKeywordsChange = useCallback((data) => {
    setJsKeywords(data);
  }, []);

  const handleImageUrlsValidation = useCallback((validationFn) => {
    setValidateImageUrls(() => validationFn);
  }, []);

  // Load approval status from sessionStorage on mount
  useEffect(() => {
    const status = sessionStorage.getItem('contentCreation_approvalStatus');
    if (status) {
      try {
        setApprovalStatus(JSON.parse(status));
      } catch (e) {
        setApprovalStatus(status);
      }
    }
    
    const batchAssignedValue = sessionStorage.getItem('contentCreation_batchAssigned');
    if (batchAssignedValue !== null) {
      setBatchAssigned(batchAssignedValue === 'true');
    }
    setIsReviewReadOnly(false);
    sessionStorage.removeItem('contentCreation_isReviewReadOnly');
    
    // Load project coding description from sessionStorage
    const description = sessionStorage.getItem('contentCreation_projectCodingDescription');
    if (description) {
      try {
        setProjectCodingDescription(JSON.parse(description));
      } catch (e) {
        setProjectCodingDescription(description);
      }
    }
  }, []);

  // Handle approval status change for AD users (approve/unapprove)
  const handleApprovalStatusChangeInHeader = async (newStatus) => {
    try {
      const projectId = sessionStorage.getItem('contentCreation_projectId');
      let entityType = sessionStorage.getItem('contentCreation_contentType');
      if (entityType && entityType.startsWith('"')) {
        entityType = JSON.parse(entityType);
      }
      let entityId = null;

      // Determine entity ID based on content type
      if (entityType === ContentTypeConstants.VIDEO.key) {
        entityId = sessionStorage.getItem('contentCreation_selectedVideo');
      } else if (entityType === ContentTypeConstants.NOTES.key) {
        entityId = sessionStorage.getItem('contentCreation_selectedNote');
      } else if (entityType === ContentTypeConstants.MCQ.key || entityType === ContentTypeConstants.QUIZ.key) {
        entityId = sessionStorage.getItem('contentCreation_selectedQuestion');
      } else if (entityType === ContentTypeConstants.CODING.key) {
        entityId = sessionStorage.getItem('contentCreation_selectedQuestion');
      } else if (entityType === ContentTypeConstants.PROJECT_CODING.key) {
        entityId = sessionStorage.getItem('contentCreation_selectedQuestion');
      }
      
      // Parse values (they may be stored as JSON strings)
      const projectIdInt = parseInt(JSON.parse(projectId || '0'));
      let entityTypeStr = entityType;
      if (entityType && entityType.startsWith('"')) {
        entityTypeStr = JSON.parse(entityType);
      }
      if (typeof entityTypeStr === 'string') {
        entityTypeStr = entityTypeStr.toLowerCase().replace(/\s+/g, '_');
      }
      let entityIdStr = entityId;
      if (entityId && entityId.startsWith('"')) {
        entityIdStr = JSON.parse(entityId);
      }
      
      // Map content type to entity type for API
      const entityTypeMap = {
        [ContentTypeConstants.VIDEO.key]: ContentTypeConstants.VIDEO.key,
        [ContentTypeConstants.NOTES.key]: ContentTypeConstants.NOTES.key,
        [ContentTypeConstants.MCQ.key]: ContentTypeConstants.MCQ.key,
        [ContentTypeConstants.QUIZ.key]: ContentTypeConstants.QUIZ.key,
        [ContentTypeConstants.CODING.key]: ContentTypeConstants.CODING.key,
        [ContentTypeConstants.PROJECT_CODING.key]: ContentTypeConstants.PROJECT_CODING.key
      };
      
      const finalEntityType = entityTypeMap[entityTypeStr] || ContentTypeConstants.VIDEO.key;
      
      if (!projectIdInt || !entityIdStr) {
        return;
      }

      const requestBody = {
        project_id: projectIdInt,
        entity_type: finalEntityType,
        entity_id: String(entityIdStr),
        approval_status: newStatus.toLowerCase()
      };
      
      const response = await apiPut(`${config.API_BASE_URL}/api/update-approval-status/`, requestBody);
      
      if (response.data.success && response.data.approval_status) {
        // Update local state
        setApprovalStatus(response.data.approval_status);
        
        // Update session storage with new approval status
        sessionStorage.setItem('contentCreation_approvalStatus', JSON.stringify(response.data.approval_status));
      } else {
      }
    } catch (error) {
      toast.error('Failed to update approval status: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Event handlers

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const refreshOutput = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const openModal = () => {
    if (
      selectedDifficulty === "default" &&
      (contentType === ContentTypeConstants.CODING.key ||
        contentType === ContentTypeConstants.MCQ.key ||
        contentType === ContentTypeConstants.QUIZ.key ||
        contentType === ContentTypeConstants.VIDEO.key ||
        contentType === ContentTypeConstants.NOTES.key)
    ) {
      toast.warning("Please Select Difficulty Level");
      return;
    } else if (contentType === ContentTypeConstants.QUIZ.key) {
      const validationError = validateQuizForm({
        question: mcqQuestion,
        options: quizOptions,
        explanation: mcqExplanation,
        template: quizTemplate,
      });
      if (validationError) {
        toast.warning(validationError);
      } else {
        setIsModalOpen(true);
      }
    } else if (contentType === ContentTypeConstants.MCQ.key) {
      if (mcqQuestion.trim() === "") {
        toast.warning("Please enter Question");
      } else if (
        options.option1.trim() === "" ||
        options.option2.trim() === "" ||
        options.option3.trim() === "" ||
        options.option4.trim() === ""
      ) {
        toast.warning("Please fill all the options");
      } else if (!mcqExplanation || mcqExplanation.trim() === "") {
        toast.warning("Please enter Explanation");
      } else {
        setIsModalOpen(true);
      }
    } else if (contentType === ContentTypeConstants.VIDEO.key) {
      const videoFileInput = document.getElementById("videoFile");
      const isEditVideo = currentFile && currentFile !== CONSTANTS.DEFAULT_QN;
      const hasNewFile = videoFileInput?.files?.[0];
      if (!isEditVideo && (!videoFileInput || !hasNewFile)) {
        toast.warning("Please select a video file");
      } else if (
        !videoTitle.trim() ||
        !videoSequence ||
        !videoTime ||
        String(videoSequence || "").trim() === "" ||
        String(videoTime || "").trim() === ""
      ) {
        toast.warning("Please fill all required fields: title, sequence, and time");
      } else if (parseInt(videoSequence) <= 0 || parseInt(videoTime) < 0) {
        toast.warning("Sequence and time must be positive numbers");
      } else {
        setIsModalOpen(true);
      }
    } else if (contentType === ContentTypeConstants.NOTES.key) {
      // Get current content directly from editor if available
      let currentContent = notesContent || '';
      if (notesFormRef.current?.getCurrentContent) {
        try {
          const editorContent = notesFormRef.current.getCurrentContent();
          if (editorContent?.trim()) {
            currentContent = editorContent;
            if (currentContent !== notesContent) {
              setNotesContent(currentContent);
            }
          }
        } catch (error) {
          // Continue with state content if editor access fails
        }
      }
      
      // Validate fields
      const sequenceStr = String(notesSequence || "").trim();
      const timeStr = String(notesTime || "").trim();
      const missingFields = [];
      
      if (!notesTitle?.trim()) missingFields.push("Title");
      if (!hasMeaningfulContent(currentContent)) missingFields.push("Content");
      if (!sequenceStr) missingFields.push("Sequence");
      if (!timeStr) missingFields.push("Time");
      
      if (missingFields.length > 0) {
        toast.warning(`Please enter: ${missingFields.join(", ")}`);
      } else if (parseInt(notesSequence) <= 0 || parseInt(notesTime) < 0) {
        toast.warning("Sequence and time must be positive numbers");
      } else {
        setIsModalOpen(true);
      }
    } else if (contentType === ContentTypeConstants.PROJECT_CODING.key) {
      if (!projectComponentRef.current) {
        return;
      }
      const ok =
        typeof projectComponentRef.current.validateSaveFields === 'function'
          ? projectComponentRef.current.validateSaveFields()
          : true;
      if (ok) {
        setIsModalOpen(true);
      }
    } else if (isCoding(contentType) && selectedEditor === EditorConstants.FRONTEND_CODING.key) {
      // Frontend/HTML editor validation (task name only exists in this editor)
      if (!pageName || pageName.trim() === '') {
        toast.warning('Please enter a task before saving.');
        return;
      }

      // Check requirements content from session storage or codingQuestionText (for coding) or selectedQuestion
      const currentQuestionContent = sessionStorage.getItem('currentQuestionContent') || 
                                     (isCoding(contentType) ? codingQuestionText : selectedQuestion);
      if (!currentQuestionContent || currentQuestionContent.trim() === '') {
        toast.warning('Please enter requirements before saving.');
        return;
      }
      
      // Validate image URLs before showing confirmation dialog
      if (validateImageUrls) {
        const validationResult = validateImageUrls();
        if (!validationResult.isValid) {
          toast.warning(validationResult.message);
          return;
        }
      }
      // Check if test cases are generated for all files (excluding DefaultTemplate.html and JS files)
      const filesWithoutTestCases = htmlFiles.filter(file => {
        // Skip DefaultTemplate.html from test case validation
        if (file.name === 'DefaultTemplate.html') return false;
        
        // Skip JS files - they use manual test case creation instead of generation
        if (file.name.endsWith('.js')) return false;
        
        const testCases = htmlTestCases[file.name];
        return (
          !testCases || !testCases.structure || testCases.structure.length === 0
        );
      });

      if (filesWithoutTestCases.length > 0) {
        const fileNames = filesWithoutTestCases
          .map((file) => file.name)
          .join(", ");
        toast.warning(
          `Please generate test cases for all files before saving. Missing test cases for: ${fileNames}`
        );
        return;
      }

      const modifiedFiles = htmlFiles.filter(file => {
        // Skip DefaultTemplate.html from modification validation
        if (file.name === 'DefaultTemplate.html') return false;
        
        const hasTestCases = !!(htmlTestCases[file.name] && Array.isArray(htmlTestCases[file.name].structure) && htmlTestCases[file.name].structure.length >= 0);
        const isModified = fileModificationTracker[file.id];
        return hasTestCases && isModified;
      });

      if (modifiedFiles.length > 0) {
        const fileNames = modifiedFiles.map((file) => file.name).join(", ");
        setFilesToRegenerate(modifiedFiles);
        setShowRegenerateModal(true);
        return;
      }

      // Check if test cases are empty for any file (excluding DefaultTemplate.html and JS files)
      const filesWithEmptyTestCases = htmlFiles.filter(file => {
        // Skip DefaultTemplate.html from empty test case validation
        if (file.name === 'DefaultTemplate.html') return false;
        
        // Skip JS files - they use manual test case creation instead of generation
        if (file.name.endsWith('.js')) return false;
        
        const testCases = htmlTestCases[file.name];

        return (
          !testCases || !testCases.structure || testCases.structure.length === 0
        );
      });

      if (filesWithEmptyTestCases.length > 0) {
        const fileNames = filesWithEmptyTestCases
          .map((file) => file.name)
          .join(", ");
        toast.warning(
          `Test cases are empty for the following files. Please generate test cases for: ${fileNames}`
        );
        return;
      }

      // No validation restrictions - allow saving with any validation status
      
      setIsModalOpen(true);
    } else if (isCoding(contentType) && (selectedEditor === EditorConstants.PYTHON_CODING.key || selectedEditor === EditorConstants.SQL_CODING.key)) {
      // Python / SQL editor: no task name or HTML validations, go straight to confirm modal
      setIsModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "question") {
      setMCQQuestion(value);
    } else if (name === "explanation") {
      setMCQExplanation(value);
    } else if (name.startsWith("option")) {
      setOptions((prevOptions) => ({
        ...prevOptions,
        [name]: value,
      }));
    }
  };

  const confirmSave = async () => {
    if (isMCQ(contentType)) {
      if (currentFile === CONSTANTS.DEFAULT_QN) {
        handleMCQSubmit();
      } else {
        handleMCQUpdate();
      }
    } else if (isCoding(contentType)) {
      if (selectedEditor === EditorConstants.SQL_CODING.key) {
        saveSQL();
      } else if (selectedEditor === EditorConstants.FRONTEND_CODING.key) {
        saveHTML();
      } else {
        if (currentFile === CONSTANTS.DEFAULT_QN) {
          saveJson();
        } else {
          EditJson();
        }
      }
    } else if (contentType === ContentTypeConstants.VIDEO.key) {
      if (currentFile === CONSTANTS.DEFAULT_QN) {
        handleVideoSubmit();
      } else {
        handleVideoUpdate();
      }
    } else if (contentType === ContentTypeConstants.NOTES.key) {
      handleNotesSubmit();
    } else if (contentType === ContentTypeConstants.PROJECT_CODING.key) {
      if (projectComponentRef.current) {
        setIsSaveLoading(true);
        try {
          const questionId = await projectComponentRef.current.handleSave();
          // Update approval status after save for project_coding
          if (questionId) {
            await updateApprovalStatusAfterSave(questionId);
            sessionStorage.setItem('contentCreation_approvalStatus', JSON.stringify('uploaded'));
            setApprovalStatus('uploaded');
            showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
          }
        } catch (error) {
          console.error('Error saving project_coding:', error);
          toast.error('Failed to save project content. Please try again.');
        } finally {
          setIsSaveLoading(false);
        }
      }
    }
    setIsModalOpen(false);
  };

  const handleSubTopicChange = (e) => {
    setSelectedSubTopicWithSession(e.target.value);
    // Reset form fields
    setdefaultTemplate("");
    setCode1("");
    setCode2("");
    setTestCases([]);
    setKeywords([]);
    settags([]);
    setExplain([]);
    setHints([]);
    setExamples([]);
    refreshOutput();
    setSelectedQuestion("");
    setMCQQuestion("");
    setOptions({
      option1: "",
      option2: "",
      option3: "",
      option4: "",
    });
    setCurrentFile(CONSTANTS.DEFAULT_QN);
    setSelectedDifficultyWithSession("default");
    setMCQExplanation("");
    setmcqtags([]);
    // Reset notes state
    setNotesTitle("");
    setNotesContent("");
    setNotesSequence("");
    setNotesTime("");
    setNotesLevel("level1");
    setNotesStatus(CONSTANTS.ACTIVE);
    // Reset video state
    setVideoTitle("");
    setVideoSequence("");
    setVideoTime("");
    setVideoStatus(CONSTANTS.ACTIVE);
    // Reset HTML state
    setPageName("");
    setHtmlFiles([]);
    setHtmlTestCases({});
    setHtmlRequirements([]);
    setHtmlTemplate("");
  };

  const handleNotesLevelChange = (e) => {
    const selectedLevel = e.target.value;
    setNotesLevel(selectedLevel);

    if (selectedLevel === "") {
      // Show all notes when no level is selected
      const allNotesList = Object.values(allNotes).flat();
      setFilteredNotes(allNotesList);
      setDisplayFiles(allNotesList);
    } else {
      // Show only notes for the selected level
      const levelNotes = allNotes[selectedLevel] || [];
      setFilteredNotes(levelNotes);
      setDisplayFiles(levelNotes);
    }
  };

  const handleTopicChange = (e) => {
    const topicId = e.target.value;
    setSelectedSubTopicWithSession("");
    setSelectedTopicWithSession(topicId);
    const topic = topics.find((topic) => topic.topic_id === topicId);
    if (topic) {
      setSubTopics(topic.sub_topics);
      // Reset form fields
      setdefaultTemplate("");
      setCode1("");
      setCode2("");
      setTestCases([]);
      setKeywords([]);
      settags([]);
      setExplain([]);
      setHints([]);
      setSelectedDifficultyWithSession("default");
      setCurrentFile(CONSTANTS.DEFAULT_QN);
      refreshOutput();
      setSelectedQuestion("");
      setMCQQuestion("");
      setOptions({
        option1: "",
        option2: "",
        option3: "",
        option4: "",
      });
      setMCQExplanation("");
      setmcqtags([]);
      // Reset notes state
      setNotesTitle("");
      setNotesContent("");
      setNotesSequence("");
      setNotesTime("");
      setNotesLevel("level1");
      setNotesStatus(CONSTANTS.ACTIVE);
    } else {
      setSubTopics([]);
      // Reset form fields
      setdefaultTemplate("");
      setCode1("");
      setCode2("");
      setTestCases([]);
      setKeywords([]);
      settags([]);
      setExplain([]);
      setHints([]);
      setSelectedDifficultyWithSession("default");
      setExamples([]);
      refreshOutput();
      setSelectedQuestion("");
      setMCQQuestion("");
      setOptions({
        option1: "",
        option2: "",
        option3: "",
        option4: "",
      });
      setMCQExplanation("");
      setmcqtags([]);
      // Reset notes state
      setNotesTitle("");
      setNotesContent("");
      setNotesSequence("");
      setNotesTime("");
      setNotesLevel("level1");
      setNotesStatus(CONSTANTS.ACTIVE);
    }
  };

  const handleContentTypeChange = (e) => {
    setContentTypeWithSession(e.target.value);
    setCurrentFile(CONSTANTS.DEFAULT_QN);
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      const fileType = file.name.split(".").pop()?.toLowerCase();

      if (fileType === "csv") {
        reader.onload = function (event) {
          const csvData = event.target?.result;
          if (csvData) {
            const parsedData = Papa.parse(csvData, {
              header: true,
              skipEmptyLines: true,
            });
            const filteredData = parsedData.data.filter((row) =>
              Object.values(row).some((value) => value !== "")
            );
            insertDataIntoDatabase(filteredData);
          }
        };
        reader.readAsText(file);
      } else if (fileType === "xlsx" || fileType === "xls") {
        reader.onload = function (event) {
          const data = new Uint8Array(event.target?.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName],
            { header: 1, raw: false }
          );
          const headers = worksheet[0];
          const rows = worksheet.slice(1).map((row) => {
            if (Array.isArray(row)) {
              let obj = {};
              headers.forEach((header, i) => {
                const cellValue = row[i];
                obj[header] = cellValue != null ? String(cellValue) : "";
              });
              return obj;
            }
            return {};
          });
          const filteredRows = rows.filter((row) =>
            Object.values(row).some((value) => value !== "")
          );
          insertDataIntoDatabase(filteredRows);
        };
        reader.readAsArrayBuffer(file);
      } else {
        toast.warning("Unsupported file format. Please upload a CSV or Excel file.");
      }
      e.target.value = '';
    }
  };

  const insertDataIntoDatabase = async (data) => {
    try {
      setIsLoading(true);
      const createdBy = sessionStorage.getItem("Email");
      const transformedData = data.map((row, index) => {
        return {
          "Sl no": String(index + 1),
          Question: row.Question || row.question || "",
          Option1: row.Option1 || row.option1 || "",
          Option2: row.Option2 || row.option2 || "",
          Option3: row.Option3 || row.option3 || "",
          Option4: row.Option4 || row.option4 || "",
          Explanation: row.Explanation || row.explanation || "",
          subtopic_id: row.subtopic_id || row.subtopic_id || "",
          Level: row.Level || row.level || "",
          Template: row.Template || row.template || 1,
          Tags: row.Tags || row.tags || [],
        };
      });

      // Prepare the bulk upload payload
      const bulkUploadPayload = {
        created_by: createdBy,
        data: transformedData,
      };

      // Make API call to bulk upload MCQ data
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/mcq/bulk-upload`,
        bulkUploadPayload
      );

      if (response.status === 200 || response.status === 201) {
        // Check if the response has the expected structure
        if (response.data && response.data.message) {
          const { message, success_count, error_count, failed_questions } =
            response.data;

          if (error_count === 0) {
            // All questions uploaded successfully
            setModalMessage(
              `${message}\n\nSuccessfully imported ${success_count} MCQ questions!`
            );
          } else {
            // Some questions failed
            const failedDetails =
              failed_questions.length > 0
                ? `\n\nFailed questions: ${failed_questions.join(", ")}`
                : "";
            setModalMessage(
              `${message}\n\nSuccessfully imported: ${success_count}\nFailed: ${error_count}${failedDetails}`
            );
          }
        } else {
          // Fallback message if response structure is different
          setModalMessage(
            `Successfully imported ${data.length} MCQ questions!`
          );
        }

        setResShowModal(true);

        // Refresh the MCQ form data
        setMCQQuestion("");
        setOptions({
          option1: "",
          option2: "",
          option3: "",
          option4: "",
        });
        setMCQExplanation("");
        setmcqtags([]);
      } else {
        const errorMessage =
          response.data?.message ||
          response.statusText ||
          "Unknown error occurred";
        setModalMessage(`Failed to upload MCQ data: ${errorMessage}`);
        setResShowModal(true);
      }
    } catch (error) {
      setModalMessage(`Error importing MCQ data: ${error.message}`);
      setResShowModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const saveJson = async () => {
    setIsLoading(true);
    // For coding questions, use codingQuestionText; for others, read from textarea or use selectedQuestion
    const question = document.querySelector("#que")?.value || (isCoding(contentType) ? codingQuestionText : selectedQuestion);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const createdBy = sessionStorage.getItem("Email");
    const testCaseObjects = [
      { Testcase: keywords },
      ...testCases.map((testCase, index) => ({ [`Testcase`]: testCase })),
    ];
    const explanationObjects = explain.map((explanation, index) => ({
      [`Explanation${index + 1}`]: explanation,
    }));
    const hintObjects = hints.map((hint, index) => ({
      [`Hint${index + 1}`]: hint,
    }));
    const exObjects = examples.map((example, index) => ({
      [`Example`]: example,
    }));
    const levelToUse = (selectedDifficulty === "level1" || selectedDifficulty === "level2" || selectedDifficulty === "level3") ? selectedDifficulty : "level1";
    const jsonObject = {
      editor: selectedEditor,
      subtopic_id: selectedSubTopic,
      level: levelToUse,
      type: ContentTypeConstants.CODING.key,
      question_types_enum: selectedEditor,
      Name: CONSTANTS.PYTHON,
      QNty: "PY",
      CreatedON: formattedDate,
      QnTy: "code",
      MultiSelect: "0",
      QnTe: "MC9.htm",
      CreatedBy: createdBy,
      Tags: tags,
      Qn: question,
      Template: defaultTemplate,
      Examples: exObjects,
      Ans: code1,
      FunctionCall: code2,
      TestCases: testCaseObjects,
      Explanations: explanationObjects,
      Hints: hintObjects,
      LastUpdated: "",
    };
    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/course-plan/`,
        jsonObject
      );
      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        // Use currentFile or get it from session storage if not available, OR from response if new content
        const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
          ? currentFile 
          : (response.data?.question_id || JSON.parse(sessionStorage.getItem('contentCreation_selectedQuestion') || 'null'));
        if (isAssignedContent && contentIdForUpdate) {
          await updateApprovalStatusAfterSave(contentIdForUpdate);
        }

        showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
        // setdefaultTemplate("");
        // setCode1("");
        // setCode2("");
        // setTestCases([]);
        // setKeywords([]);
        // settags([]);
        // setExplain([]);
        // setHints([]);
        // setExamples([]);
        // setCurrentFile(CONSTANTS.DEFAULT_QN);
        
        // Update currentFile to the saved question ID
        const savedQuestionId = response.data?.question_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedQuestionId) {
            setCurrentFile(savedQuestionId);
        } else {
            setCurrentFile(CONSTANTS.DEFAULT_QN);
        }

        refreshOutput();
        // setSelectedQuestion("");
        fetchNameOfFile();
        fetchCount();
      }
    } catch (error) {
    }
    setIsLoading(false);
  };

  const EditJson = async () => {
    setIsLoading(true);
    // For coding questions, use codingQuestionText; for others, read from textarea or use selectedQuestion
    const question = document.querySelector("#que")?.value || (isCoding(contentType) ? codingQuestionText : selectedQuestion);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const createdBy = sessionStorage.getItem("Email");
    const testCaseObjects = [
      { Testcase: keywords },
      ...testCases.map((testCase, index) => ({ [`Testcase`]: testCase })),
    ];
    const explanationObjects = explain.map((explanation, index) => ({
      [`Explanation${index + 1}`]: explanation,
    }));
    const hintObjects = hints.map((hint, index) => ({
      [`Hint${index + 1}`]: hint,
    }));
    const exObjects = examples.map((example, index) => ({
      [`Example`]: example,
    }));
    const levelToUse = (selectedDifficulty === "level1" || selectedDifficulty === "level2" || selectedDifficulty === "level3") ? selectedDifficulty : "level1";
    const jsonObject = {
      editor: selectedEditor,
      subtopic_id: selectedSubTopic,
      level: levelToUse,
      type: ContentTypeConstants.CODING.key,
      question_types_enum: selectedEditor,
      Name: CONSTANTS.PYTHON,
      QNty: "PY",
      QnTy: "code",
      MultiSelect: "0",
      QnTe: "MC9.htm",
      Tags: tags,
      Qn: question,
      Template: defaultTemplate,
      Examples: exObjects,
      Ans: code1,
      FunctionCall: code2,
      TestCases: testCaseObjects,
      Explanations: explanationObjects,
      Hints: hintObjects,
      currentFile: currentFile,
      LastUpdated: currentFile ? formattedDate : "",
      Last_Updated_by: sessionStorage.getItem("Email"),
    };
    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/course-plan/`,
        jsonObject
      );
      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
          ? currentFile 
          : (response.data?.question_id || JSON.parse(sessionStorage.getItem('contentCreation_selectedQuestion') || 'null'));
        
        if (isAssignedContent && contentIdForUpdate) {
          await updateApprovalStatusAfterSave(contentIdForUpdate);
        }

        showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
        // setdefaultTemplate("");
        // setCode1("");
        // setCode2("");
        // setTestCases([]);
        // setKeywords([]);
        // settags([]);
        // setExplain([]);
        // setHints([]);
        // setExamples([]);
        refreshOutput();
        // setSelectedQuestion(CONSTANTS.DEFAULT_QN);
        
        // Update currentFile to the saved question ID
        const savedQuestionId = response.data?.question_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedQuestionId) {
            setCurrentFile(savedQuestionId);
        } else {
            setCurrentFile(CONSTANTS.DEFAULT_QN);
        }
      }
    } catch (error) {
    }
    setIsLoading(false);
  };

  const handleVideoSubmit = async () => {
    if (selectedDifficulty === "default") {
      setError("Please Select Difficulty Level");
      return;
    }

    if (
      !videoTitle ||
      !videoSequence ||
      !videoTime ||
      String(videoSequence || "").trim() === "" ||
      String(videoTime || "").trim() === ""
    ) {
      setError("Title, sequence, and time are required!");
      return;
    }

    // Check if video file is selected
    const videoFileInput = document.getElementById("videoFile");
    if (!videoFileInput || !videoFileInput.files[0]) {
      setError("Please select a video file!");
      return;
    }

    const sequenceNum = parseInt(videoSequence);
    const timeNum = parseInt(videoTime);

    if (sequenceNum <= 0 || timeNum < 0) {
      setError("Sequence and time must be positive numbers!");
      return;
    }
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("subtopic_id", selectedSubTopic);
      formData.append("level", selectedDifficulty);
      formData.append("time", videoTime);
      formData.append("sequence", videoSequence);
      formData.append("title", videoTitle);
      formData.append("status", videoStatus);
      formData.append("file", videoFileInput.files[0]);
      formData.append("created_by", sessionStorage.getItem("Email"));
      formData.append("createdOn", new Date().toISOString());
      
      // If this is assigned content, send the video_id to update existing
      const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
      if (isAssignedContent && currentFile && currentFile !== CONSTANTS.DEFAULT_QN) {
        formData.append("video_id", currentFile);
      }

      const response = await apiPostFormData(
        `${config.API_BASE_URL}/api/content_creation/upload-video-temp/`,
        formData
      );

      if (response.status === 200) {
        // Update approval status if this is an assigned content
        if (isAssignedContent) {
          // Use currentFile if updating, or database_id from response if creating new
          const contentId = (currentFile && currentFile !== CONSTANTS.DEFAULT_QN) 
            ? currentFile 
            : response.data?.database_id;
            
          if (contentId) {
            await updateApprovalStatusAfterSave(contentId);
          } else {
          }
        }

        // setVideoTitle("");
        // setVideoSequence("");
        // setVideoTime("");
        // setVideoStatus(CONSTANTS.ACTIVE);
        
        // Update currentFile to the saved video ID
        const savedVideoId = response.data?.database_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedVideoId) {
            setCurrentFile(savedVideoId);
        } else {
            setCurrentFile(CONSTANTS.DEFAULT_QN);
        }

        // Clear the file input
        // if (videoFormRef.current) {
        //   videoFormRef.current.clearFileInput();
        // }
        fetchNameOfFile();
        setError("");
      } else {
        setError("There was an issue submitting the video.");
      }
    } catch (error) {
      setError("There was an issue submitting the video.");
    }
    setIsLoading(false);
  };

  const handleVideoUpdate = async () => {
    if (!selectedSubTopic) {
      setError("Please select a subtopic!");
      return;
    }
    if (selectedDifficulty === "default") {
      setError("Please Select Difficulty Level");
      return;
    }

    if (
      !videoTitle ||
      !videoSequence ||
      !videoTime ||
      String(videoSequence || "").trim() === "" ||
      String(videoTime || "").trim() === ""
    ) {
      setError("Title, sequence, and time are required!");
      return;
    }

    // When editing (existing video selected in dropdown), a new file is optional
    const videoFileInput = document.getElementById("videoFile");
    const hasNewFile = videoFileInput?.files?.[0];
    if (!currentFile || currentFile === CONSTANTS.DEFAULT_QN) {
      if (!videoFileInput || !hasNewFile) {
        setError("Please select a video file!");
        return;
      }
    }

    const sequenceNum = parseInt(videoSequence);
    const timeNum = parseInt(videoTime);

    if (sequenceNum <= 0 || timeNum < 0) {
      setError("Sequence and time must be positive numbers!");
      return;
    }
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("sub_topic_id", selectedSubTopic);
      formData.append("level", selectedDifficulty);
      formData.append("time", videoTime);
      formData.append("sequence", videoSequence);
      formData.append("title", videoTitle);
      formData.append("status", videoStatus);
      formData.append("file", hasNewFile ? videoFileInput.files[0] : "null");
      formData.append("video_id", currentFile);
      formData.append("updated_by", sessionStorage.getItem("Email"));
      formData.append("updatedOn", new Date().toISOString());

      const response = await apiPostFormData(
        `${config.API_BASE_URL}/api/content_creation/upload-video-temp/`,
        formData
      );

      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        const contentId = (currentFile && currentFile !== CONSTANTS.DEFAULT_QN) 
            ? currentFile 
            : response.data?.database_id;
            
        if (isAssignedContent && contentId) {
            await updateApprovalStatusAfterSave(contentId);
        }

        // setVideoTitle("");
        // setVideoSequence("");
        // setVideoTime("");
        // setVideoStatus(CONSTANTS.ACTIVE);
        
        // Update currentFile to the saved video ID
        const savedVideoId = response.data?.database_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedVideoId) {
            setCurrentFile(savedVideoId);
        } else {
            setCurrentFile(CONSTANTS.DEFAULT_QN);
        }

        // Clear the file input
        // if (videoFormRef.current) {
        //   videoFormRef.current.clearFileInput();
        // }
        fetchNameOfFile();
        setError("");
      } else {
        setError("There was an issue updating the video.");
      }
    } catch (error) {
      setError("There was an issue updating the video.");
    }
    setIsLoading(false);
  };

  // Function to clean HTML content by removing CSS styling
  const cleanHtmlContent = (htmlContent) => {
    if (!htmlContent) return "";

    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    // Remove all style attributes from elements
    const elementsWithStyle = tempDiv.querySelectorAll("[style]");
    elementsWithStyle.forEach((element) => {
      element.removeAttribute("style");
    });

    // Remove all class attributes that might contain styling
    const elementsWithClass = tempDiv.querySelectorAll("[class]");
    elementsWithClass.forEach((element) => {
      element.removeAttribute("class");
    });

    // Remove any <style> tags
    const styleTags = tempDiv.querySelectorAll("style");
    styleTags.forEach((style) => style.remove());

    // Remove any <link> tags (external CSS)
    const linkTags = tempDiv.querySelectorAll('link[rel="stylesheet"]');
    linkTags.forEach((link) => link.remove());

    // Get the cleaned HTML content
    return tempDiv.innerHTML;
  };

  const handleNotesSubmit = async () => {
    if (selectedDifficulty === "default") {
      setError("Please Select Difficulty Level");
      return;
    }

    const sequenceStr = String(notesSequence ?? "").trim();
    const timeStr = String(notesTime ?? "").trim();
    const contentToSave = notesFormRef.current?.getCurrentContent ? notesFormRef.current.getCurrentContent() : notesContent;
    if (
      !notesTitle ||
      !contentToSave ||
      !sequenceStr ||
      !timeStr
    ) {
      setError("Title, content, sequence, and time are required!");
      return;
    }

    const sequenceNum = parseInt(sequenceStr);
    const timeNum = parseInt(timeStr);

    if (sequenceNum <= 0 || timeNum < 0) {
      setError("Sequence and time must be positive numbers!");
      return;
    }
    setIsLoading(true);
    try {
      const createdBy = sessionStorage.getItem("Email");

      const notesData = {
        subtopic_id: selectedSubTopic,
        type: ContentTypeConstants.NOTES.key,
        sequence: sequenceNum,
        title: notesTitle,
        content: contentToSave,
        time: timeNum,
        level: selectedDifficulty, // Use selectedDifficulty instead of notesLevel
        status: notesStatus,
        created_by: createdBy,
        createdOn: new Date().toISOString(),
      };

      // If a note is selected (not "Create New Notes"), include the notes_id
      if (currentFile !== CONSTANTS.DEFAULT_QN) {
        notesData.notes_id = currentFile;
      }

      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/notes/`,
        notesData
      );

      // Update approval status if this is an assigned content
      const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
      // Use currentFile or get it from session storage if not availabl
      const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
        ? currentFile 
        : (response.data?.id || JSON.parse(sessionStorage.getItem('contentCreation_selectedNote') || 'null'));
      if (isAssignedContent && contentIdForUpdate) {
        await updateApprovalStatusAfterSave(contentIdForUpdate);
      }

      // Clear form fields
      // setNotesTitle("");
      // setNotesContent("");
      // setNotesSequence("");
      // setNotesTime("");
      // setNotesLevel("level1");
      // setNotesStatus(CONSTANTS.ACTIVE);
      
      const savedNoteId = response.data?.id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
      
      setError("");

      // Refresh notes list first so DisplayFiles has "notes1", "notes2" etc before selecting.
      // Then set currentFile - avoids briefly showing "Notes 499" in the dropdown.
      await fetchNameOfFile();
      if (savedNoteId) {
        setCurrentFile(savedNoteId);
      } else {
        setCurrentFile(CONSTANTS.DEFAULT_QN);
      }

      // Show success message
      showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
    } catch (error) {
      setError("There was an issue submitting the notes.");
    }
    setIsLoading(false);
  };

  const updateApprovalStatusAfterSave = async (contentId) => {
    try {
      const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
      const projectId = JSON.parse(sessionStorage.getItem('contentCreation_projectId') || 'null');
      const projectIdForStatusUpdate = JSON.parse(sessionStorage.getItem('contentCreation_projectIdForStatusUpdate') || 'null');
      
      // Check if we should update approval status: assigned content, or project context (projectId set from ProjectContentBank)
      const shouldUpdate = (isAssignedContent || (projectId && projectIdForStatusUpdate) || projectId) && contentId;
      if (!shouldUpdate) {
        return; // Not an assigned content or no project context, skip status update
      }

      // Use projectIdForStatusUpdate if available, otherwise use projectId
      const finalProjectId = projectIdForStatusUpdate || projectId;
      if (!finalProjectId) {  
        return;
      }

      let contentEntityType = sessionStorage.getItem('contentCreation_contentEntityType');
      if (contentEntityType) {
        try {
          contentEntityType = JSON.parse(contentEntityType);
        } catch (e) {
          // If parsing fails, use the value as-is (already a string)
        }
      } else {
        // Fallback to contentType to determine entity type
        const contentType = sessionStorage.getItem('contentCreation_contentType');
        if (contentType) {
          try {
            const parsedContentType = JSON.parse(contentType);
            // Map contentType to entity type
            if (parsedContentType === ContentTypeConstants.PROJECT_CODING.key) {
              contentEntityType = ContentTypeConstants.PROJECT_CODING.key;
            } else if (parsedContentType === ContentTypeConstants.VIDEO.key) {
              contentEntityType = ContentTypeConstants.VIDEO.key;
            } else if (parsedContentType === ContentTypeConstants.NOTES.key) {
              contentEntityType = ContentTypeConstants.NOTES.key;
            } else if (parsedContentType === ContentTypeConstants.MCQ.key) {
              contentEntityType = ContentTypeConstants.MCQ.key;
            } else if (parsedContentType === ContentTypeConstants.QUIZ.key) {
              contentEntityType = ContentTypeConstants.QUIZ.key;
            } else if (parsedContentType === ContentTypeConstants.CODING.key) {
              contentEntityType = ContentTypeConstants.CODING.key;
            } else {
              contentEntityType = ContentTypeConstants.VIDEO.key; // default
            }
          } catch (e) {
            contentEntityType = ContentTypeConstants.VIDEO.key; // default
          }
        } else {
          contentEntityType = ContentTypeConstants.VIDEO.key; // default
        }
      }

      // Normalize entity type to lowercase
      const normalizedEntityType = String(contentEntityType).toLowerCase();

      const entityTypeMap = {
        [ContentTypeConstants.VIDEO.key]: ContentTypeConstants.VIDEO.key,
        [ContentTypeConstants.NOTES.key]: ContentTypeConstants.NOTES.key,
        [ContentTypeConstants.MCQ.key]: ContentTypeConstants.MCQ.key,
        [ContentTypeConstants.QUIZ.key]: ContentTypeConstants.QUIZ.key,
        [ContentTypeConstants.CODING.key]: ContentTypeConstants.CODING.key,
        [ContentTypeConstants.PROJECT_CODING.key]: ContentTypeConstants.PROJECT_CODING.key
      };

      const requestBody = {
        project_id: finalProjectId,
        entity_id: String(contentId),
        entity_type: entityTypeMap[normalizedEntityType] || ContentTypeConstants.VIDEO.key,
        approval_status: 'uploaded'
      };
      const response = await apiPut(`${config.API_BASE_URL}/api/update-approval-status/`, requestBody);
      const isSuccess = response?.data?.success === true || response?.status === 200;
      if (isSuccess) {
        // Read approval_status from response (may be nested in .data)
        const newStatus = response?.data?.approval_status ?? response?.data?.data?.approval_status ?? 'uploaded';
        const statusStr = String(newStatus).toLowerCase();

        sessionStorage.setItem('contentCreation_approvalStatus', JSON.stringify(statusStr));
        setApprovalStatus(statusStr);

        // Clear the session storage flags
        sessionStorage.removeItem('contentCreation_isAssignedContent');
        sessionStorage.removeItem('contentCreation_contentEntityType');
        sessionStorage.removeItem('contentCreation_projectIdForStatusUpdate');
      }
    } catch (error) {
      // Don't show error to user as content was already saved successfully
    }
  };

  const handleMCQSubmit = async () => {
    setIsLoading(true);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const questionType = isQuiz(contentType)
      ? ContentTypeConstants.QUIZ.key
      : ContentTypeConstants.MCQ.key;
    const quizPayload = isQuiz(contentType)
      ? buildQuizQuestionData({
          question: mcqQuestion,
          options: quizOptions,
          template: quizTemplate,
          explanation: mcqExplanation,
          subtopicId: selectedSubTopic,
          level: selectedDifficulty,
        })
      : null;
    const mcqData = isQuiz(contentType)
      ? {
          subtopic_id: selectedSubTopic,
          level: selectedDifficulty,
          CreatedBy: sessionStorage.getItem("Email"),
          type: questionType,
          question_types_enum: questionType,
          CreatedON: formattedDate,
          LastUpdated: "",
          Tags: mcqtags,
          metadata: quizPayload.metadata,
          content: quizPayload.content,
          answer: quizPayload.answer,
        }
      : {
          subtopic_id: selectedSubTopic,
          level: selectedDifficulty,
          CreatedBy: sessionStorage.getItem("Email"),
          type: questionType,
          question_types_enum: questionType,
          question: mcqQuestion,
          options: [
            options.option1,
            options.option2,
            options.option3,
            options.option4,
          ],
          CreatedON: formattedDate,
          Template: selectedTemplate,
          LastUpdated: "",
          correct_answer: options.option1,
          Explanation: mcqExplanation,
          Tags: mcqtags,
        };
    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/course-plan/`,
        mcqData
      );
      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        // Use currentFile or get it from session storage if not available, OR from response if new content
        const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
          ? currentFile 
          : (response.data?.question_id || JSON.parse(sessionStorage.getItem('contentCreation_selectedQuestion') || 'null'));
        if (isAssignedContent && contentIdForUpdate) {
          await updateApprovalStatusAfterSave(contentIdForUpdate);
        }

        showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
        
        // Update currentFile to the saved question ID
        const savedQuestionId = response.data?.question_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedQuestionId) {
            setCurrentFile(savedQuestionId);
        } else {
            setCurrentFile(CONSTANTS.DEFAULT_QN);
        }
      }
      fetchNameOfFile();
      fetchCount();
    } catch (error) {
    }
    setIsLoading(false);
  };

  const handleMCQUpdate = async () => {
    setIsLoading(true);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const questionType = isQuiz(contentType)
      ? ContentTypeConstants.QUIZ.key
      : ContentTypeConstants.MCQ.key;
    const quizPayload = isQuiz(contentType)
      ? buildQuizQuestionData({
          question: mcqQuestion,
          options: quizOptions,
          template: quizTemplate,
          explanation: mcqExplanation,
          subtopicId: selectedSubTopic,
          level: selectedDifficulty,
        })
      : null;
    const mcqData = isQuiz(contentType)
      ? {
          subtopic_id: selectedSubTopic,
          level: selectedDifficulty,
          Last_Updated_by: sessionStorage.getItem("Email"),
          type: questionType,
          question_types_enum: questionType,
          currentFile: currentFile,
          LastUpdated: currentFile ? formattedDate : "",
          Tags: mcqtags,
          metadata: quizPayload.metadata,
          content: quizPayload.content,
          answer: quizPayload.answer,
        }
      : {
          subtopic_id: selectedSubTopic,
          level: selectedDifficulty,
          Last_Updated_by: sessionStorage.getItem("Email"),
          type: questionType,
          question_types_enum: questionType,
          question: mcqQuestion,
          options: [
            options.option1,
            options.option2,
            options.option3,
            options.option4,
          ],
          currentFile: currentFile,
          LastUpdated: currentFile ? formattedDate : "",
          correct_answer: options.option1,
          Explanation: mcqExplanation,
          Tags: mcqtags,
          Template: selectedTemplate,
        };
    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/course-plan/`,
        mcqData
      );

      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        // For HTML, response.data.question_id is what we need
        const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
          ? currentFile 
          : (response.data?.question_id || JSON.parse(sessionStorage.getItem('contentCreation_selectedQuestion') || 'null'));
        
        if (isAssignedContent && contentIdForUpdate) {
          await updateApprovalStatusAfterSave(contentIdForUpdate);
        }

        showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
        
        // Update currentFile to the saved question ID
        const savedQuestionId = response.data?.question_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedQuestionId) {
            setCurrentFile(savedQuestionId);
        } else {
            setCurrentFile(CONSTANTS.DEFAULT_QN);
        }
      }
    } catch (error) {
    }

    setIsLoading(false);
  };

  const getFormattedData = () => {
    const textAreas = document.querySelectorAll("textarea");
    const formattedExplanations = Array.from(textAreas)
      .filter((textArea) => textArea.id.startsWith("textArea-exp"))
      .map((textArea) => ({
        Explanation: textArea.value,
      }));
    const formattedTags = Array.from(textAreas)
      .filter((textArea) => textArea.id.startsWith("textArea-tag"))
      .map((textArea) => textArea.value.trim());
    const formattedHints = Array.from(textAreas)
      .filter((textArea) => textArea.id.startsWith("textArea-hint"))
      .map((textArea) => ({
        Hint: textArea.value,
      }));
    const formattedTestcase = Array.from(textAreas)
      .filter((textArea) => textArea.id.startsWith("textArea-testcase"))
      .map((textArea) => ({ Testcase: textArea.value.trim() }));
    return {
      Expl: formattedExplanations,
      Hints: formattedHints,
      Tags: formattedTags,
      Testcase: formattedTestcase,
    };
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const createdBy = sessionStorage.getItem("Email");
    if (!isQueryrun) {
      toast.warning("Please run the query once before saving the content");
      return;
    }
    const formattedData = getFormattedData();
    const dataToSubmit = {
      CreatedOn:
        new Date()
          .toISOString()
          .replace("Z", new Date().getTimezoneOffset() <= 0 ? "+" : "-") +
        (new Date().getTimezoneOffset() / 60).toFixed(0).padStart(2, "0") +
        ":" +
        (new Date().getTimezoneOffset() % 60).toString().padStart(2, "0"),
      Level: selectedDifficulty,
      Qn: sqlqn,
      Ans: sqlquery,
      CreatedBy: createdBy,
      table: sqltable,
      Expl: formattedData.Expl,
      Hints: formattedData.Hints,
      Tags: formattedData.Tags,
      Testcase: formattedData.Testcase,
    };
    setFormData(dataToSubmit);
  };

  const saveSQL = async () => {
    setIsLoading(true);
    if (!formData) {
      return;
    }
    const explanationObjects = sqlexplain.map((explanation, index) => ({
      [`Explanation${index + 1}`]: explanation,
    }));
    const hintObjects = sqlhints.map((hint, index) => ({
      [`Hint${index + 1}`]: hint,
    }));
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    // Get display test cases (exclude last one as it's the expected output)
    const displayTestCases = SQLTestCases.length > 0 ? SQLTestCases.slice(0, -1) : SQLTestCases;
    
    const testcaseObjects = displayTestCases.map((testCase) => ({
      Testcase: testCase,
    }));
    
    // Add expected output as the last test case (as array, same format as ExpectedOutput)
    if (sqlExpectedOutput && Array.isArray(sqlExpectedOutput) && sqlExpectedOutput.length > 0) {
      testcaseObjects.push({
        Testcase: sqlExpectedOutput,
      });
    }
    
    let abcjson;
    if (currentFile === CONSTANTS.DEFAULT_QN) {
      abcjson = {
        editor: selectedEditor,
        subtopic_id: selectedSubTopic,
        type: ContentTypeConstants.CODING.key,
        question_types_enum: EditorConstants.SQL_CODING.key,
        CreatedBy: sessionStorage.getItem("Email"),
        Ans: sqlquery,
        level: selectedDifficulty,
        Qn: sqlqn,
        Name: CONSTANTS.SQL,
        Table: sqltable,
        Tags: sqltags,
        Hints: hintObjects,
        TestCases: testcaseObjects,
        Explanations: explanationObjects,
        CreatedOn: formattedDate,
        LastUpdated: "",
        ExpectedOutput: sqlExpectedOutput && Array.isArray(sqlExpectedOutput) ? sqlExpectedOutput : [], // Always include ExpectedOutput key
      };
    } else if (currentFile !== CONSTANTS.DEFAULT_QN) {
      abcjson = {
        editor: selectedEditor,
        subtopic_id: selectedSubTopic,
        type: ContentTypeConstants.CODING.key,
        question_types_enum: EditorConstants.SQL_CODING.key,
        Ans: sqlquery,
        level: selectedDifficulty,
        Qn: sqlqn,
        Name: CONSTANTS.SQL,
        Table: sqltable,
        Tags: sqltags,
        Hints: hintObjects,
        TestCases: testcaseObjects,
        Explanations: explanationObjects,
        currentFile: currentFile,
        LastUpdated: currentFile ? formattedDate : "",
        Last_Updated_by: sessionStorage.getItem("Email"),
        ExpectedOutput: sqlExpectedOutput && Array.isArray(sqlExpectedOutput) ? sqlExpectedOutput : [], // Always include ExpectedOutput key
      };
    }
    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/course-plan/`,
        abcjson
      );
      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
          ? currentFile 
          : (response.data?.question_id || JSON.parse(sessionStorage.getItem('contentCreation_selectedQuestion') || 'null'));
        
        if (isAssignedContent && contentIdForUpdate) {
          await updateApprovalStatusAfterSave(contentIdForUpdate);
        }

        showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
        // Do not clear form fields to keep the saved content loaded
        // setsqlQuery("");
        // setsqlQn("");
        // setTable("");
        // setsqlTags([]);
        // setsqlHints([]);
        // setsqlExplain([]);
        // setSQLTestCases([]);
        // setdefaultTemplate("");
        // setCode1("");
        // setCode2("");
        // setTestCases([]);
        // setKeywords([]);
        // settags([]);
        // setExplain([]);
        // setHints([]);
        // setExamples([]);
        
        // Update currentFile to the saved question ID
        const savedQuestionId = response.data?.question_id || (currentFile !== CONSTANTS.DEFAULT_QN ? currentFile : null);
        if (savedQuestionId) {
          setCurrentFile(savedQuestionId);
        } else {
          setCurrentFile(CONSTANTS.DEFAULT_QN);
        }
        
        refreshOutput();
        // setSelectedQuestion("");
        fetchNameOfFile();
        fetchCount();
      }
    } catch (error) {
    }
    setIsLoading(false);
  };

  const handleClose = () => {
    setResShowModal(false);
    // Refresh the data after bulk upload modal closes
    if (contentType === ContentTypeConstants.MCQ.key) {
      fetchNameOfFile();
      fetchCount();
    }
  };

  // HTML form handlers
  const handleDefaultTemplateChange = (content) => {
    setDefaultTemplateContent(content);
  };

  const handleImageUploaded = (imageUrl) => {
    setImagePath(imageUrl);
  };

  const handleVideoUploaded = (videoUrl) => {
    setVideoPath(videoUrl);
  };

  const handleGenerateTestCases = async (data) => {
    try {
      setIsLoading(true);

      // If data contains selectedTestCases, store them
      if (data && typeof data === "object" && data.selectedTestCases) {
        // Store in the same format as the payload structure
        const codeValidation = {};

        // Process each file to create the payload format
        htmlFiles.forEach((file) => {
          // Skip DefaultTemplate.html - it's handled separately
          if (file.name === "DefaultTemplate.html") return;

          const fileTestCases = data.generatedTestCases[file.name] || [];
          const selectedCases = data.selectedTestCases[file.name] || {};

          // Store ONLY selected test cases in structure, sorted by original index
          const structure = [];

          // First, collect all selected test cases with their original indices
          const selectedTestCasesWithIndex = [];
          fileTestCases.forEach((testCase, index) => {
            const testCaseKey = `${file.name}_${index}`;
            if (selectedCases[testCaseKey]) {
              selectedTestCasesWithIndex.push({
                testCase: {
                ...testCase,
                },
                originalIndex: index
              });
            }
          });

          selectedTestCasesWithIndex.sort((a, b) => a.originalIndex - b.originalIndex);

          // Extract the sorted test cases
          selectedTestCasesWithIndex.forEach(({ testCase }) => {
            structure.push(testCase);
          });

          codeValidation[file.name] = {
            structure: structure,
            Ans: file.content || "", // Store the actual code written by user
          };
        });

        // Store the processed data in payload format
        setHtmlTestCases(codeValidation);
        setHtmlSelectedTestCases(data.selectedTestCases);
      } else {
        // This would call your backend API to generate test cases
        // For now, we'll simulate the response
        const mockTestCases = {};
        setHtmlTestCases(mockTestCases);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddRequirement = (fileName, requirement) => {
    const newRequirement = {
      fileName,
      message: `Requirement for ${requirement.tag}: ${JSON.stringify(
        requirement
      )}`,
      requirement,
    };
    setHtmlRequirements((prev) => [...prev, newRequirement]);
  };

  // Function to mark file as modified
  const markFileAsModified = (fileId) => {
    setFileModificationTracker((prev) => ({
      ...prev,
      [fileId]: true,
    }));
  };

  // Function to mark file as unmodified (after test case generation)
  const markFileAsUnmodified = (fileId) => {
    setFileModificationTracker((prev) => ({
      ...prev,
      [fileId]: false,
    }));
  };

  // Function to cancel regeneration
  const handleCancelRegeneration = () => {
    setShowRegenerateModal(false);
    setFilesToRegenerate([]);
  };

  // Function to load HTML question data from API
  const loadHTMLQuestionData = (jsonData) => {
    // Set loading state
    setIsQuestionLoading(true);
    
    // Clear existing test cases first to ensure clean state
    setHtmlTestCases({});
    setHtmlSelectedTestCases({});
    
    // Clear JS data first
    setJsData({ elements: [] });
    jsDataRef.current = { elements: [] };
    
    // Check if we need to unwrap the data
    const actualData = jsonData.question_data || jsonData;

    // If Code_Validation is missing (e.g., for assigned but not yet created content),
    // initialize with default empty structure
    if (!actualData) {
      return;
    }

    // Initialize default structure if Code_Validation is missing
    if (!actualData.Code_Validation) {
      // Create default empty structure for HTML/CSS/JS files
      actualData.Code_Validation = {
        'index.html': { structure: [], Ans: '' },
        'styles.css': { structure: [], Ans: '' },
        'script.js': { structure: [], Ans: '' }
      };
      // Initialize Tabs if missing
      if (!actualData.Tabs || !Array.isArray(actualData.Tabs) || actualData.Tabs.length === 0) {
        actualData.Tabs = [
          { name: 'index.html', type: 'HTML' },
          { name: 'styles.css', type: 'CSS' },
          { name: 'script.js', type: 'JS' }
        ];
      }
    }
    // Load basic question data
    setPageName(actualData.Qn || "");  // Map Qn field to pageName
    setImagePath(actualData.image_path || "");
    setVideoPath(actualData.video_path || "");
    
    // Load requirements content and update sessionStorage
    if (actualData.requirements) {
      setSelectedQuestion(actualData.requirements);
      setCodingQuestionText(actualData.requirements); // Also set for coding questions
      sessionStorage.setItem('currentQuestionContent', actualData.requirements);
    } else {
      // Clear requirements if not present
      setSelectedQuestion("");
      setCodingQuestionText("");
      sessionStorage.removeItem('currentQuestionContent');
    }
    
    // Load image URLs if available
    if (actualData.image_urls && Array.isArray(actualData.image_urls)) {
      setLoadedImageUrls(actualData.image_urls);
    } else {
      setLoadedImageUrls([]);
    }
    
    // Extract question ID from the response and store in sessionStorage
    if (jsonData.question_id) {
      sessionStorage.setItem("currentQuestionId", jsonData.question_id);
      setQuestionId(jsonData.question_id);
    }

    // Load HTML files from Tabs
    if (actualData.Tabs && Array.isArray(actualData.Tabs)) {
      const htmlFiles = actualData.Tabs.map((tab) => {
        // Get the content from Code_Validation if available
        const validation = actualData.Code_Validation?.[tab.name];
        let content = validation?.Ans || '';
        
        return {
          id: tab.name,
          name: tab.name,
          type: tab.type,
          content: content,
        };
      });

      // Load default template content
      if (actualData.defaulttemplate) {
        setDefaultTemplateContent(actualData.defaulttemplate);
      } else {
        setDefaultTemplateContent("");
      }

      setHtmlFiles(htmlFiles);
    }

    // Load test cases and validation data from Code_Validation
    if (actualData.Code_Validation) {
      const htmlTestCases = {};
      const selectedTestCases = {};

      Object.keys(actualData.Code_Validation).forEach((fileName) => {
        const validation = actualData.Code_Validation[fileName];

        htmlTestCases[fileName] = {
          structure: validation.structure || [],
          Ans: validation.Ans || "", // Store the actual code written by user
        };

        // Initialize test cases as checked by default (since they were saved)
        const fileSelectedTestCases = {};
        const fileTestCaseRequirements = {};

        // Mark all test cases as selected since they were saved
        if (validation.structure && Array.isArray(validation.structure)) {
          validation.structure.forEach((_, index) => {
            const testCaseKey = `${fileName}_${index}`;
            fileSelectedTestCases[testCaseKey] = true; // Mark as selected
            fileTestCaseRequirements[testCaseKey] = ""; // Empty requirement
          });
        }

        selectedTestCases[fileName] = fileSelectedTestCases;
      });

      setHtmlTestCases(htmlTestCases);
      setHtmlSelectedTestCases(selectedTestCases);
    }
    
    // Load JS structure data and keywords from Code_Validation
    const jsFilesData = {};
    const keywordsData = {};
    if (actualData.Code_Validation) {
      Object.keys(actualData.Code_Validation).forEach(fileName => {
        if (fileName.endsWith('.js')) {
          const validation = actualData.Code_Validation[fileName];
          if (validation.structure && Array.isArray(validation.structure)) {
            // Store JS structure for each file
            jsFilesData[fileName] = { elements: validation.structure };
          }
          // Load keywords if they exist
          if (validation.keywords && Array.isArray(validation.keywords)) {
            keywordsData[fileName] = validation.keywords;
          }
        }
      });
    }
    
    // Set JS data for all files
    setJsData(jsFilesData);
    jsDataRef.current = jsFilesData;
    
    // Set loaded keywords
    setLoadedKeywords(keywordsData);
    
    // Reset loading state
    setIsQuestionLoading(false);
  };

  // Set up global function for HTML data loading
  React.useEffect(() => {
    window.loadHTMLQuestionData = loadHTMLQuestionData;
    return () => {
      delete window.loadHTMLQuestionData;
    };
  }, []);

  // Clear HTML test case states when question changes
  React.useEffect(() => {
    // Clear states when switching to "Create New" or when no question is selected
    if (selectedQuestion === CONSTANTS.DEFAULT_QN) {
      setHtmlTestCases({});
      setHtmlSelectedTestCases({});
      setHtmlFiles([]);
      setDefaultTemplateContent("");
      setPageName("");
      setImagePath("");
      setVideoPath("");
      setLoadedImageUrls([]); // Clear loaded image URLs
      sessionStorage.setItem('currentQuestionId', ''); // Set to empty string for new question
      setQuestionId(''); // Clear questionId state
      
      // Clear JS data when switching to "Create New"
      setJsData({ elements: [] });
      jsDataRef.current = { elements: [] };
    }
    // Note: For existing questions, test cases will be cleared and reloaded in loadHTMLQuestionData
  }, [selectedQuestion]);

  // Also clear JS data when currentFile changes to "Create New"
  React.useEffect(() => {
    if (currentFile === CONSTANTS.DEFAULT_QN) {
      setJsData({ elements: [] });
      jsDataRef.current = { elements: [] };
    }
  }, [currentFile]);

  // Clear image and video paths when creating new question
  React.useEffect(() => {
    if (currentFile === CONSTANTS.DEFAULT_QN) {
      setImagePath("");
      setVideoPath("");
      setDefaultTemplateContent("");
      sessionStorage.removeItem('currentQuestionContent');
    }
  }, [currentFile]);


  // Initialize sessionStorage with empty string on component mount
  React.useEffect(() => {
    // Initialize with empty string if not already set
    if (!sessionStorage.getItem("currentQuestionId")) {
      sessionStorage.setItem("currentQuestionId", "");
    }
    // Initialize questionId state
    setQuestionId(sessionStorage.getItem("currentQuestionId") || "");
  }, []);

  // Listen for sessionStorage changes
  React.useEffect(() => {
    const handleStorageChange = () => {
      const currentQuestionId =
        sessionStorage.getItem("currentQuestionId") || "";
      setQuestionId(currentQuestionId);
    };

    // Listen for storage events (when sessionStorage changes in other tabs)
    window.addEventListener("storage", handleStorageChange);

    // Also check periodically for changes within the same tab
    const interval = setInterval(() => {
      const currentQuestionId =
        sessionStorage.getItem("currentQuestionId") || "";
      if (currentQuestionId !== questionId) {
        setQuestionId(currentQuestionId);
      }
    }, 100);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [questionId]);

  // Cleanup on component unmount
  React.useEffect(() => {
    return () => {
      // Clear questionId when component unmounts
      sessionStorage.removeItem("currentQuestionId");
      // Clear freezeFilters flag after component unmounts
      sessionStorage.removeItem('contentCreation_freezeFilters');
      sessionStorage.removeItem('contentCreation_isReviewReadOnly');
    };
  }, []);

  const saveHTML = async () => {
    setIsLoading(true);
    
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const createdBy = sessionStorage.getItem("Email");

    // Store the question ID in sessionStorage after successful save
    // This will be used for file uploads
    if (currentFile !== CONSTANTS.DEFAULT_QN) {
      // For existing questions, keep the current questionId
      // For new questions, we'll get the ID from the API response
    }

    // Create the JSON format matching your expected structure
    const tabs = htmlFiles.map((file) => ({
      name: file.name,
      type: file.type,
    }));

    const codeValidation = {};
  
    
    // Create validation structure for each file with selected test cases and requirements
    htmlFiles.forEach((file) => {
      // Skip DefaultTemplate.html - it's handled separately in defaulttemplate field
      if (file.name === 'DefaultTemplate.html') return;
      
      // Handle JS files with manual test cases
      if (file.name.endsWith('.js')) {
        const selectedJs = htmlTestCases[file.name]?.structure;
        codeValidation[file.name] = {
          structure: Array.isArray(selectedJs) ? selectedJs : [],
          Ans: file.content || "" // Store the actual code written by user
        };
        
        // Include keywords for this JS file if they exist
        const fileKeywords = jsKeywords[file.name];
        if (fileKeywords && Array.isArray(fileKeywords) && fileKeywords.length > 0) {
          // Filter out empty keywords and add as array
          const nonEmptyKeywords = fileKeywords.filter(k => k && k.trim() !== '').map(k => k.trim());
          if (nonEmptyKeywords.length > 0) {
            codeValidation[file.name].keywords = nonEmptyKeywords;
          }
        }
        return;
      }
      
      // Handle HTML/CSS files with generated test cases
      const testCasesData = htmlTestCases[file.name];
      if (testCasesData && testCasesData.structure) {
        // Data is already in payload format, just copy it
        codeValidation[file.name] = {
          structure: testCasesData.structure,
          Ans: file.content || "", // Store the actual code written by user
        };
      }
    });

    // Get the current question content from session storage
    const currentQuestionContent = sessionStorage.getItem('currentQuestionContent') || '';
    
    // Prepare the HTML content data structure in the expected format
    const htmlData = {
      editor: selectedEditor,
      Page_Name: pageName,
      level: selectedDifficulty,
      subtopic_id: selectedSubTopic,
      type: ContentTypeConstants.CODING.key,
      question_types_enum: EditorConstants.FRONTEND_CODING.key,
      Tabs: tabs,
      Qn: pageName,  
      requirements: currentQuestionContent,
      Code_Validation: codeValidation,
      image_path: imagePath,
      video_path: videoPath,
      image_urls: imageUrls, // Add image URLs to save payload
      CreatedBy: createdBy,
      CreatedOn: formattedDate,
      LastUpdated: currentFile === CONSTANTS.DEFAULT_QN ? "" : formattedDate,
      currentFile:
        currentFile === CONSTANTS.DEFAULT_QN ? undefined : currentFile,
      Last_Updated_by:
        currentFile === CONSTANTS.DEFAULT_QN ? undefined : createdBy,
    };

    // Only include defaulttemplate if it has content
    if (defaultTemplateContent && defaultTemplateContent.trim() !== '') {
      htmlData.defaulttemplate = defaultTemplateContent;
    }

    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/course-plan/`,
        htmlData
      );

      if (response.status === 200) {
        // Update approval status if this is an assigned content
        const isAssignedContent = sessionStorage.getItem('contentCreation_isAssignedContent') === 'true';
        // For HTML, response.data.question_id is what we need
        const contentIdForUpdate = currentFile && currentFile !== CONSTANTS.DEFAULT_QN 
          ? currentFile 
          : (response.data?.question_id || JSON.parse(sessionStorage.getItem('contentCreation_selectedQuestion') || 'null'));
        
        if (isAssignedContent && contentIdForUpdate) {
          await updateApprovalStatusAfterSave(contentIdForUpdate);
        }

        showSaveSuccess(currentFile !== CONSTANTS.DEFAULT_QN);
        setHtmlSaveResetKey((k) => k + 1);

        // Handle question ID from response
        if (response.data && response.data.question_id) {
          sessionStorage.setItem("currentQuestionId", response.data.question_id);
          setQuestionId(response.data.question_id);
          setCurrentFile(response.data.question_id);
            const event = { target: { value: response.data.question_id } };
            handleQuestionChange(event);
        fetchNameOfFile();
        fetchCount();
        }
      }
    } catch (error) {
    }
    setIsLoading(false);
  };

  // MCQ form handlers
  const handleMCQtagChange = (index, newtag) => {
    const updatedtags = [...mcqtags];
    updatedtags[index] = newtag;
    setmcqtags(updatedtags);
  };

  const addMCQtag = () => {
    setmcqtags([...mcqtags, ""]);
  };

  // Content form handlers
  const addVideoInput = () => {
    setVideoFile(null);
    setVideoDescription("");
    setVideoTime("0");
    setVideoLevel("level1");
  };

  const addFileInput = () => {
    setFiles([...files, { file: null, text: "", time: "0", level: "level1" }]);
  };

  const handleVideoFileChange = (e) => {
    setVideoFile(e.target.files[0]);
  };

  const handleVideoDescriptionChange = (e) => {
    setVideoDescription(e.target.value);
  };

  const handleVideoTimeChange = (e) => {
    setVideoTime(e.target.value);
  };

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const validTypes = [
      "text/plain",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/html",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ];

    const maxSize = 5 * 1024 * 1024; // 5MB file size limit

    if (!validTypes.includes(file.type)) {
      setError(
        "Invalid file type. Only .txt, .pdf, .doc, .docx, .ppt, .pptx, .html are allowed."
      );
      return;
    }
    if (file.size > maxSize) {
      setError("File size is too large. Maximum allowed size is 5MB.");
      return;
    }

    const updatedFiles = [...files];
    updatedFiles[index].file = file;
    setFiles(updatedFiles);
  };

  const handleFileDescriptionChange = (e, index) => {
    const updatedFiles = [...files];
    updatedFiles[index].text = e.target.value;
    setFiles(updatedFiles);
  };

  const handleFileTimeChange = (e, index) => {
    const updatedFiles = [...files];
    updatedFiles[index].time = e.target.value;
    setFiles(updatedFiles);
  };

  const handleFileLevelChange = (e, index) => {
    const updatedFiles = [...files];
    updatedFiles[index].level = e.target.value;
    setFiles(updatedFiles);
  };

  const removeVideo = () => {
    setVideoFile(null);
    setVideoDescription("");
    setVideoTime("0");
    setVideoLevel("level1");
  };

  const removeFile = (index) => {
    const updatedFiles = files.filter((_, idx) => idx !== index);
    setFiles(updatedFiles);
  };

  // Coding form handlers
  const handleExampleValueChange = (exampleIndex, valueIndex, newValue) => {
    const updatedExamples = [...examples];
    updatedExamples[exampleIndex].Inputs[valueIndex] = newValue;
    setExamples(updatedExamples);
  };

  const handleExampleOutputChange = (exampleIndex, newOutput) => {
    const updatedExamples = [...examples];
    updatedExamples[exampleIndex].Output = newOutput;
    setExamples(updatedExamples);
  };

  const handleExampleExplanationChange = (exampleIndex, newExplanation) => {
    const updatedExamples = [...examples];
    updatedExamples[exampleIndex].Explanation = newExplanation;
    setExamples(updatedExamples);
  };

  const addExampleValue = (exampleIndex) => {
    const updatedExamples = [...examples];
    updatedExamples[exampleIndex].Inputs.push("");
    setExamples(updatedExamples);
  };

  const removeExampleValue = (exampleIndex, valueIndex) => {
    setExamples((prevExamples) => {
      const updatedExamples = [...prevExamples];
      if (updatedExamples[exampleIndex]) {
        const updatedValues = [...updatedExamples[exampleIndex].Inputs];
        updatedValues.splice(valueIndex, 1);
        updatedExamples[exampleIndex] = {
          ...updatedExamples[exampleIndex],
          Inputs: updatedValues,
        };
      }
      return updatedExamples;
    });
  };

  const addExample = () => {
    setExamples([...examples, { Inputs: [""], Output: "", Explanation: "" }]);
  };

  const removeExample = (exampleIndex) => {
    const updatedExamples = examples.filter((_, i) => i !== exampleIndex);
    setExamples(updatedExamples);
  };

  const handleTestCaseValueChange = (testCaseIndex, valueIndex, newValue) => {
    const updatedTestCases = [...testCases];
    updatedTestCases[testCaseIndex].Value[valueIndex] = newValue;
    setTestCases(updatedTestCases);
  };

  const handleTestCaseOutputChange = (testCaseIndex, newOutput) => {
    const updatedTestCases = [...testCases];
    updatedTestCases[testCaseIndex].Output = newOutput;
    setTestCases(updatedTestCases);
  };

  const addTestCaseValue = (testCaseIndex) => {
    const updatedTestCases = [...testCases];
    updatedTestCases[testCaseIndex].Value.push("");
    setTestCases(updatedTestCases);
  };

  const removeTestCaseValue = (testCaseIndex, valueIndex) => {
    setTestCases((prevTestCases) => {
      const updatedTestCases = [...prevTestCases];
      if (updatedTestCases[testCaseIndex]) {
        const updatedValues = [...updatedTestCases[testCaseIndex].Value];
        updatedValues.splice(valueIndex, 1);
        updatedTestCases[testCaseIndex] = {
          ...updatedTestCases[testCaseIndex],
          Value: updatedValues,
        };
      }
      return updatedTestCases;
    });
  };

  const addTestCase = () => {
    setTestCases([...testCases, { Value: [""], Output: "" }]);
  };

  const removeTestCase = (testCaseIndex) => {
    const updatedTestCases = testCases.filter((_, i) => i !== testCaseIndex);
    setTestCases(updatedTestCases);
  };

  const handleKeywordChange = (index, newKeyword) => {
    const updatedKeywords = [...keywords];
    updatedKeywords[index] = newKeyword;
    setKeywords(updatedKeywords);
  };

  const addKeyword = () => {
    setKeywords([...keywords, ""]);
  };

  const handletagChange = (index, newtag) => {
    const updatedtags = [...tags];
    updatedtags[index] = newtag;
    settags(updatedtags);
  };

  const addtag = () => {
    settags([...tags, ""]);
  };

  const addExplanation = () => {
    setExplain((prevExplain) => [...prevExplain, ""]);
  };

  const handleExplainChange = (index, value) => {
    setExplain((prevExplain) => {
      const updatedExplain = [...prevExplain];
      updatedExplain[index] = value;
      return updatedExplain;
    });
  };

  const addHint = () => {
    setHints((prevHints) => [...prevHints, ""]);
  };

  const handleHintChange = (index, value) => {
    setHints((prevHints) => {
      const updatedHints = [...prevHints];
      updatedHints[index] = value;
      return updatedHints;
    });
  };

  // SQL form handlers
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedTables = [...selectedTables];
    if (checked) {
      updatedTables.push(value);
    } else {
      updatedTables = updatedTables.filter((table) => table !== value);
    }
    setSelectedTables(updatedTables);
    setTable(updatedTables.join(", "));
  };

  const handleRunClick = async () => {
    setIsLoading(true);
    const sqlqueryValue = sqlquery;
    try {
      const response = await apiPost(
        `${config.API_BASE_URL}/api/content_creation/execute-query/`,
        { query: sqlqueryValue }
      );
      if (response.status === 200 && response.data.data.length > 0) {
        const resultData = response.data.data;
        renderoptbl(resultData);
        // Store result data as expected output and last test case
        setSqlExpectedOutput(resultData);
        // Update last test case to be the result data
        setSQLTestCases((prevTestCases) => {
          if (prevTestCases.length > 0) {
            // Replace last item with result data
            const updated = [...prevTestCases];
            updated[updated.length - 1] = resultData;
            return updated;
          } else {
            // Add result data as the only test case
            return [resultData];
          }
        });
      } else {
        renderNoDataMessage();
      }
    } catch (error) {
      renderNoDataMessage();
    }
    setIsQueryrun(true);
    setIsLoading(false);
  };

  const renderoptbl = (data) => {
    if (!Array.isArray(data) || data.length === 0) return;
    const headers = Object.keys(data[0]);
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.borderCollapse = "collapse";
    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");
    headers.forEach((header) => {
      const th = document.createElement("th");
      th.textContent = header;
      th.style.border = "1px solid black";
      th.style.padding = "8px";
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);
    const tbody = document.createElement("tbody");
    data.forEach((item) => {
      const row = document.createElement("tr");
      headers.forEach((header) => {
        const td = document.createElement("td");
        td.textContent = item[header] !== undefined ? item[header] : "N/A";
        td.style.border = "1px solid black";
        td.style.padding = "8px";
        row.appendChild(td);
      });
      tbody.appendChild(row);
    });
    table.appendChild(tbody);
    const outputDiv = document.getElementById("expectedop");
    if (outputDiv) {
      outputDiv.innerHTML = "<h3>Output Table</h3>";
      outputDiv.appendChild(table);
    }
  };

  const renderNoDataMessage = () => {
    const outputDiv = document.getElementById("expectedop");
    if (outputDiv) {
      outputDiv.innerHTML = "<h3>Output Table</h3><p>No data available</p>";
    }
  };

  // Render ExpectedOutput in UI when it's loaded (use editor key, not subject name)
  useEffect(() => {
    if (sqlExpectedOutput && Array.isArray(sqlExpectedOutput) && sqlExpectedOutput.length > 0 && selectedEditor === EditorConstants.SQL_CODING.key) {
      renderoptbl(sqlExpectedOutput);
    }
  }, [sqlExpectedOutput, selectedEditor]);

  const addSQLExplanation = () => {
    setsqlExplain((prevExplain) => [...prevExplain, ""]);
  };

  const handleSQLExplainChange = (index, value) => {
    setsqlExplain((prevExplain) => {
      const updatedExplain = [...prevExplain];
      updatedExplain[index] = value;
      return updatedExplain;
    });
  };

  const addSQLTags = () => {
    setsqlTags((prevTags) => [...prevTags, ""]);
  };

  const handleSQLTagsChange = (index, value) => {
    setsqlTags((prevTags) => {
      const updatedTags = [...prevTags];
      updatedTags[index] = value;
      return updatedTags;
    });
  };

  const addSQLTestCase = () => {
    setSQLTestCases((prevTestCases) => {
      // Always add before the last item (which is expected output)
      if (prevTestCases.length > 0 && sqlExpectedOutput && sqlExpectedOutput.length > 0) {
        // Last item is expected output, add before it
        const newTestCases = [...prevTestCases];
        newTestCases.splice(newTestCases.length - 1, 0, "");
        return newTestCases;
      } else {
        // No expected output yet, just add
        return [...prevTestCases, ""];
      }
    });
  };

  const handleSQLTestCaseChange = (index, value) => {
    setSQLTestCases((prevTestCases) => {
      const updatedTestCases = [...prevTestCases];
      updatedTestCases[index] = value;
      return updatedTestCases;
    });
  };

  const addsqlHint = () => {
    setsqlHints((prevHints) => [...prevHints, ""]);
  };

  const handlesqlHintChange = (index, value) => {
    setsqlHints((prevHints) => {
      const updatedHints = [...prevHints];
      updatedHints[index] = value;
      return updatedHints;
    });
  };

  const renderTable = (key, tableData) => {
    if (!Array.isArray(tableData) || tableData.length === 0) {
      return null;
    }
    const columns = Object.keys(tableData[0]);
    return (
      <div key={key}>
        <h6>{key}</h6>
        <table className="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => (
                  <td key={col}>{row[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const isProjectCoding = contentType === ContentTypeConstants.PROJECT_CODING.key;

  return (
    <>
    <Box
      sx={{
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
        <Header
          navigate={navigate}
          sub_name={sub_name}
          contentType={contentType}
          openModal={openModal}
          approvalStatus={approvalStatus}
          onApprovalStatusChange={handleApprovalStatusChangeInHeader}
          batchAssigned={batchAssigned}
          containerStatus={containerStatus}
          onContainerDeleted={() => {
            setContainerStatus(null);
            try {
              sessionStorage.removeItem("projectCoding_containerStatus");
            } catch (error) {
              // ignore storage errors
            }
          }}
          isReadOnly={isReviewReadOnly}
          isSaveLoading={isSaveLoading || isLoading}
        />

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: isProjectCoding ? 'hidden' : 'auto',
            bgcolor: 'var(--color-bg-default)',
          }}
        >
          {(isLoading || loading) && (
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 9999,
              }}
            >
              <PulseLoader size={10} className="px-2" />
              <FadeLoader />
              <PulseLoader size={10} />
            </Box>
          )}

          {isProjectCoding ? (
            <Box
              sx={{
                p: 1.5,
                height: '100%',
                width: '100%',
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                gap: 1.5,
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  flexShrink: 0,
                  borderRadius: 'var(--radius-lg)',
                  bgcolor: 'background.paper',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    px: 1.5,
                    py: 0.75,
                    borderBottom: projectScopeCollapsed ? 'none' : '1px solid var(--color-border-default)',
                  }}
                >
                  <Typography variant="body2" fontWeight={600} color="text.secondary">
                    {projectScopeCollapsed ? 'Filters collapsed' : 'Filters'}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => setProjectScopeCollapsed((prev) => !prev)}
                    aria-label={projectScopeCollapsed ? 'Expand filters' : 'Collapse filters'}
                    title={projectScopeCollapsed ? 'Expand filters' : 'Collapse filters'}
                  >
                    {projectScopeCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                  </IconButton>
                </Box>
                {!projectScopeCollapsed && (
                  <Box sx={{ p: 2 }}>
                    <TopicSelector
                      topics={topics}
                      subTopics={subTopics}
                      selectedTopic={selectedTopic}
                      selectedSubTopic={selectedSubTopic}
                      contentType={contentType}
                      count={count}
                      handleTopicChange={handleTopicChange}
                      handleSubTopicChange={handleSubTopicChange}
                      handleContentTypeChange={handleContentTypeChange}
                      isContentTypeDisabled={isContentTypeDisabled}
                      freezeFilters={freezeFilters}
                      isFromProjectContentBank={freezeFilters === true || approvalStatus !== null}
                      selectedEditor={selectedEditor}
                      setSelectedEditorWithSession={setSelectedEditorWithSession}
                      currentFile={currentFile}
                    />
                    <Box sx={{ mt: 2 }}>
                      <QuestionSelector
                        contentType={contentType}
                        selectedDifficulty={selectedDifficulty}
                        currentFile={currentFile}
                        DisplayFiles={DisplayFiles}
                        handleRadioChangeDiff={handleRadioChangeDiff}
                        handleQuestionChange={handleQuestionChange}
                        selectedVideo={selectedVideo}
                        setSelectedVideoWithSession={setSelectedVideoWithSession}
                        selectedNote={selectedNote}
                        setSelectedNoteWithSession={setSelectedNoteWithSession}
                        selectedQuestion={selectedQuestion}
                        setSelectedQuestionWithSession={setSelectedQuestionWithSession}
                        allVideos={allVideos}
                        allNotes={allNotes}
                        videoDetails={videoDetails}
                        videoTitle={videoTitle}
                        notesTitle={notesTitle}
                        freezeFilters={freezeFilters}
                      />
                    </Box>
                  </Box>
                )}
              </Paper>

              <FormSection
                fillHeight
                sx={{ flex: 1, minHeight: 0, mb: 0, overflow: 'hidden' }}
              >
                {projectCodingDescription && (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1, flexShrink: 0 }}>
                    <button
                      className="btn btn-link p-0 d-flex align-items-center gap-2"
                      onClick={() => setShowDescriptionModal(true)}
                      style={{ textDecoration: 'none', color: '#0d6efd' }}
                      title="View Description"
                      type="button"
                    >
                      <FaEye size={18} />
                      <span style={{ fontSize: '14px', fontWeight: 500 }}>View Description</span>
                    </button>
                  </Box>
                )}
                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    height: '100%',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Box sx={{ flex: 1, minHeight: { xs: 480, md: 0 }, height: '100%' }}>
                    <ProjectComponent
                      ref={projectComponentRef}
                      containerStatus={containerStatus}
                      setContainerStatus={setContainerStatus}
                      isReadOnly={isReviewReadOnly}
                    />
                  </Box>
                </Box>
              </FormSection>
            </Box>
          ) : (
          <Box sx={{ p: 2, width: '100%', maxWidth: '100%' }}>
            <FormSection>
              <TopicSelector
                topics={topics}
                subTopics={subTopics}
                selectedTopic={selectedTopic}
                selectedSubTopic={selectedSubTopic}
                contentType={contentType}
                count={count}
                handleTopicChange={handleTopicChange}
                handleSubTopicChange={handleSubTopicChange}
                handleContentTypeChange={handleContentTypeChange}
                isContentTypeDisabled={isContentTypeDisabled}
                freezeFilters={freezeFilters}
                isFromProjectContentBank={freezeFilters === true || approvalStatus !== null}
                selectedEditor={selectedEditor}
                setSelectedEditorWithSession={setSelectedEditorWithSession}
                currentFile={currentFile}
              />
              {(contentType === ContentTypeConstants.CODING.key ||
                contentType === ContentTypeConstants.MCQ.key ||
                contentType === ContentTypeConstants.QUIZ.key ||
                contentType === ContentTypeConstants.NOTES.key ||
                contentType === ContentTypeConstants.VIDEO.key ||
                contentType === "default") && (
                <Box sx={{ mt: 2 }}>
                  <QuestionSelector
                    contentType={contentType}
                    selectedDifficulty={selectedDifficulty}
                    currentFile={currentFile}
                    DisplayFiles={DisplayFiles}
                    handleRadioChangeDiff={handleRadioChangeDiff}
                    handleQuestionChange={handleQuestionChange}
                    selectedVideo={selectedVideo}
                    setSelectedVideoWithSession={setSelectedVideoWithSession}
                    selectedNote={selectedNote}
                    setSelectedNoteWithSession={setSelectedNoteWithSession}
                    selectedQuestion={selectedQuestion}
                    setSelectedQuestionWithSession={setSelectedQuestionWithSession}
                    allVideos={allVideos}
                    allNotes={allNotes}
                    videoDetails={videoDetails}
                    videoTitle={videoTitle}
                    notesTitle={notesTitle}
                    freezeFilters={freezeFilters}
                  />
                </Box>
              )}
            </FormSection>

            <FormSection
              title="Author content"
              description="Fill in the fields below, then click Save in the header."
            >
              {(contentType === ContentTypeConstants.MCQ.key ||
                contentType === ContentTypeConstants.QUIZ.key) && (
                <MCQForm
                  mcqQuestion={mcqQuestion}
                  setMCQQuestion={setMCQQuestion}
                  options={options}
                  setOptions={setOptions}
                  mcqExplanation={mcqExplanation}
                  setMCQExplanation={setMCQExplanation}
                  mcqtags={mcqtags}
                  setmcqtags={setmcqtags}
                  selectedTemplate={selectedTemplate}
                  handleInputChange={handleInputChange}
                  handleMCQtagChange={handleMCQtagChange}
                  addMCQtag={addMCQtag}
                  isQuiz={isQuiz(contentType)}
                  quizOptions={quizOptions}
                  setQuizOptions={setQuizOptions}
                  quizTemplate={quizTemplate}
                  setQuizTemplate={setQuizTemplate}
                />
              )}

              {contentType === ContentTypeConstants.VIDEO.key && (
                <VideoForm
                  ref={videoFormRef}
                  videoTime={videoTime}
                  setVideoTime={setVideoTime}
                  videoTitle={videoTitle}
                  setVideoTitle={setVideoTitle}
                  videoStatus={videoStatus}
                  setVideoStatus={setVideoStatus}
                  videoSequence={videoSequence}
                  setVideoSequence={setVideoSequence}
                  isLoading={isLoading}
                  error={error}
                  selectedSubTopic={selectedSubTopic}
                  videoDetails={videoDetails}
                  handleVideoStatus={handleVideoStatus}
                />
              )}

              {contentType === ContentTypeConstants.NOTES.key && (
                <NotesForm
                  ref={notesFormRef}
                  notesContent={notesContent}
                  setNotesContent={setNotesContent}
                  notesTitle={notesTitle}
                  setNotesTitle={setNotesTitle}
                  notesTime={notesTime}
                  setNotesTime={setNotesTime}
                  notesStatus={notesStatus}
                  setNotesStatus={setNotesStatus}
                  notesSequence={notesSequence}
                  setNotesSequence={setNotesSequence}
                  notesLevel={notesLevel}
                  setNotesLevel={setNotesLevel}
                  currentFile={currentFile}
                  setCurrentFile={setCurrentFile}
                  DisplayFiles={DisplayFiles}
                  isLoading={isLoading}
                  selectedSubTopic={selectedSubTopic}
                  selectedSubTopicName={selectedSubTopicName}
                  handleNotesLevelChange={handleNotesLevelChange}
                />
              )}

              {contentType === ContentTypeConstants.CODING.key && (
                <>
                  {selectedEditor === EditorConstants.PYTHON_CODING.key && (
                    <CodingForm
                      selectedQuestion={codingQuestionText}
                      setSelectedQuestion={setCodingQuestionText}
                      defaultTemplate={defaultTemplate}
                      setdefaultTemplate={setdefaultTemplate}
                      code1={code1}
                      setCode1={setCode1}
                      code2={code2}
                      setCode2={setCode2}
                      examples={examples}
                      setExamples={setExamples}
                      keywords={keywords}
                      setKeywords={setKeywords}
                      tags={tags}
                      settags={settags}
                      explain={explain}
                      setExplain={setExplain}
                      hints={hints}
                      setHints={setHints}
                      testCases={testCases}
                      setTestCases={setTestCases}
                      refreshKey={refreshKey}
                      handleExampleValueChange={handleExampleValueChange}
                      handleExampleOutputChange={handleExampleOutputChange}
                      handleExampleExplanationChange={
                        handleExampleExplanationChange
                      }
                      addExampleValue={addExampleValue}
                      removeExampleValue={removeExampleValue}
                      addExample={addExample}
                      removeExample={removeExample}
                      handleTestCaseValueChange={handleTestCaseValueChange}
                      handleTestCaseOutputChange={handleTestCaseOutputChange}
                      addTestCaseValue={addTestCaseValue}
                      removeTestCaseValue={removeTestCaseValue}
                      addTestCase={addTestCase}
                      removeTestCase={removeTestCase}
                      handleKeywordChange={handleKeywordChange}
                      addKeyword={addKeyword}
                      handletagChange={handletagChange}
                      addtag={addtag}
                      addExplanation={addExplanation}
                      handleExplainChange={handleExplainChange}
                      addHint={addHint}
                      handleHintChange={handleHintChange}
                    />
                  )}

                  {selectedEditor === EditorConstants.SQL_CODING.key && (
                    <SQLForm
                      sqlqn={sqlqn}
                      setsqlQn={setsqlQn}
                      sqltable={sqltable}
                      setTable={setTable}
                      sqlquery={sqlquery}
                      setsqlQuery={setsqlQuery}
                      selectedTables={selectedTables}
                      handleCheckboxChange={handleCheckboxChange}
                      handleRunClick={handleRunClick}
                      sqlexplain={sqlexplain}
                      setsqlExplain={setsqlExplain}
                      sqlhints={sqlhints}
                      setsqlHints={setsqlHints}
                      sqltags={sqltags}
                      setsqlTags={setsqlTags}
                      SQLTestCases={SQLTestCases}
                      setSQLTestCases={setSQLTestCases}
                      sqldata={sqldata}
                      sqlerror={sqlerror}
                      renderTable={renderTable}
                      addSQLExplanation={addSQLExplanation}
                      handleSQLExplainChange={handleSQLExplainChange}
                      addsqlHint={addsqlHint}
                      handlesqlHintChange={handlesqlHintChange}
                      addSQLTags={addSQLTags}
                      handleSQLTagsChange={handleSQLTagsChange}
                      addSQLTestCase={addSQLTestCase}
                      handleSQLTestCaseChange={handleSQLTestCaseChange}
                    />
                  )}

                  {selectedEditor === EditorConstants.FRONTEND_CODING.key && (
                    <HTMLForm
                      selectedQuestion={selectedQuestion}
                      setSelectedQuestion={setSelectedQuestion}
                      pageName={pageName}
                      setPageName={setPageName}
                      files={htmlFiles}
                      setFiles={setHtmlFiles}
                      loadedTestCases={htmlTestCases}
                      loadedSelectedTestCases={htmlSelectedTestCases}
                      loadedDefaultTemplate={defaultTemplateContent}
                      jsData={jsData}
                      onJSDataChange={handleJSDataChange}
                      imagePath={imagePath}
                      videoPath={videoPath}
                      questionId={questionId}
                      onGenerateTestCases={handleGenerateTestCases}
                      onFileModified={markFileAsModified}
                      onTestCasesGenerated={markFileAsUnmodified}
                      onDefaultTemplateChange={handleDefaultTemplateChange}
                      onImageUploaded={handleImageUploaded}
                      onVideoUploaded={handleVideoUploaded}
                      resetTrigger={htmlSaveResetKey}
                      isQuestionLoading={isQuestionLoading}
                      onImageUrlsValidation={handleImageUrlsValidation}
                      onImageUrlsChange={handleImageUrlsChange}
                      loadedImageUrls={loadedImageUrls}
                      loadedKeywords={loadedKeywords}
                      onKeywordsChange={handleKeywordsChange}
                    />
                  )}
                </>
              )}

            </FormSection>
          </Box>
          )}
        </Box>
    </Box>

        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          onConfirm={confirmSave}
          isLoading={isSaveLoading}
        />
        <HTMLModal
          isOpen={isHtmlModalOpen}
          onRequestClose={() => setIsHtmlModalOpen(false)}
          contentLabel="MCQ Preview"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.75)",
            },
            content: {
              maxWidth: "80%",
              margin: "auto",
              padding: "15px",
              borderRadius: "8px",
              background: "#fff",
              overflow: "auto",
            },
          }}
        >
          <div className="position-absolute top-0 start-0 ms-2 mt-2">
            <label className="fw-bold">Choose Template : </label>
            <select
              value={selectedTemplate}
              onChange={(e) => setSelectedTemplate(e.target.value)}
              className="form-select form-select-sm d-inline-block w-auto ms-2"
            >
              <option value="1">Template 1</option>
              <option value="2">Template 2</option>
              <option value="3">Template 3</option>
            </select>
          </div>
          <div className="d-flex justify-content-end mt-0">
            <button
              className="btn btn-danger btn-sm"
              onClick={() => setIsHtmlModalOpen(false)}
            >
              X
            </button>
          </div>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </HTMLModal>

        <ResModal
          show={resShowModal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <ResModal.Header closeButton>
            <ResModal.Title>Response</ResModal.Title>
          </ResModal.Header>
          <ResModal.Body>
            <pre>{modalMessage}</pre>
          </ResModal.Body>
          <ResModal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </ResModal.Footer>
        </ResModal>

        {/* Regenerate Test Cases Modal */}
        <ResModal
          show={showRegenerateModal}
          onHide={handleCancelRegeneration}
          backdrop="static"
          keyboard={false}
        >
          <ResModal.Header closeButton>
            <ResModal.Title>
              Code Modified - Regenerate Test Cases
            </ResModal.Title>
          </ResModal.Header>
          <ResModal.Body>
            <p>
              The following files have been modified after test case generation:
            </p>
            <ul>
              {filesToRegenerate.map((file) => (
                <li key={file.id}>
                  <strong>{file.name}</strong>
                </li>
              ))}
            </ul>
            <p>Please regenerate test cases for these files before saving.</p>
          </ResModal.Body>
        </ResModal>

        {/* Project Coding Description Modal */}
        <CustomModal
          show={showDescriptionModal}
          onHide={() => setShowDescriptionModal(false)}
          title="Project Coding Description"
          content={
            <div style={{ whiteSpace: "pre-wrap", fontFamily: "monospace", fontSize: "14px" }}>
              {projectCodingDescription}
            </div>
          }
          error={null}
          centered={true}
          size="xl"
          showFooter={true}
          footerText="Close"
        />
    </>
  );
}

export default ContentCreationRefactored;

